<template>
  <el-form
    :label-position="labelPosition"
    :label-width="labelWidthFilter"
    :model="model"
    :rules="rules"
    @submit.native.prevent="doFilter"
    class="filter"
    ref="form"
  >

    <el-row :gutter="16" class="filter__container"> 
      <!-- Name -->
      <el-col :lg="11" :md="11" :sm="24">
        <el-form-item :prop="fields.fullName.name">
          <div class="form__item__label__slot" slot="label">
            <span>{{fields.fullName.label}}</span>
            <el-button v-if="model.fullName" type="text" @click="resetFieldFilter({ fieldKey: 'fullName'})"><app-i18n code="common.reset"/></el-button>
          </div>
          <el-input
            clearable
            prefix-icon="icon-player"
            :placeholder="fields.fullName.label"
            v-model="model[fields.fullName.name]"
            @input.native="debounceInput"
            @clear="doFilter"
          />
        </el-form-item>
      </el-col>

      <!-- Email -->
      <el-col :lg="11" :md="11" :sm="24">
        <el-form-item :prop="fields.email.name">
          <div class="form__item__label__slot" slot="label">
            <span>{{fields.email.label}}</span>
            <el-button v-if="model.email" type="text" @click="resetFieldFilter({ fieldKey: 'email'})"><app-i18n code="common.reset"/></el-button>
          </div>
          <el-input
            clearable
            prefix-icon="icon-player"
            :placeholder="fields.email.label"
            v-model="model[fields.email.name]"
            @input.native="debounceInput"
            @clear="doFilter"
          />
        </el-form-item>
      </el-col>

      <!-- Filter buttons -->
      <el-col :lg="2" :md="2" :sm="24">
        <div class="filter-buttons">
          <el-button
            :disabled="loading"
            @click="doResetFilter"
            icon="icon-undo"
            circle
          />
        </div>
      </el-col>
    </el-row>

    <!-- <el-row>
      <el-col :lg="12" :md="16" :sm="24">
        <el-form-item :label="fields.status.label" :prop="fields.status.name">
          <el-select placeholder v-model="model[fields.status.name]">
            <el-option :value="undefined">--</el-option>
            <el-option
              :key="option.id"
              :label="option.label"
              :value="option.id"
              v-for="option in fields.status.options"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row> -->

  </el-form>
</template>

<script>
import { AuditLogPermissions } from '@modules/audit-log/audit-log-permissions';
import { mapGetters, mapActions } from 'vuex';
import { FilterSchema } from '@shared/form/filter-schema';
import { i18n } from '@shared/i18n';
import { UserModel } from '@modules/auth/user-model';
import _ from 'lodash';

export default {
  name: 'app-iam-list-filter',

  data() {
    return {
      model: {},
    };
  },

  computed: {
    ...mapGetters({
      labelPosition: 'layout/labelPosition',
      labelWidthFilter: 'layout/labelWidthFilter',
      loading: 'iam/list/loading',
      filter: 'iam/list/filter',
      currentUser: 'auth/currentUser',
      dateFormat: 'auth/manage/dateFormat',
      timeFormat: 'auth/manage/timeFormat',
    }),

    hasPermissionToAuditLogs() {
      return new AuditLogPermissions(this.currentUser).read;
    },

    rules() {
      const { filterSchema } = this;
      return filterSchema.rules()
    },

    filterSchema() {
      const { fields } = this;
      return new FilterSchema([
        fields.id,
        fields.fullName,
        fields.email,
      ]);
    },

    fields() {
      const { dateFormat, timeFormat} = this;
      return new UserModel({ dateFormat, timeFormat }).fields();
    },
  },

  async mounted() {
    const { filterSchema } = this;
    this.model = filterSchema.initialValues(
      this.filter,
      this.$route.query,
    );

    //return this.doFilter();
  },

  methods: {
    ...mapActions({
      doReset: 'iam/list/doReset',
      doFetch: 'iam/list/doFetch',
    }),

    async doResetFilter() {
      const { filterSchema } = this;
      this.model = filterSchema.initialValues();
      this.$refs.form.clearValidate();
      return this.doReset();
    },

    async resetFieldFilter({ fieldKey }) {
      if (this.model[`${fieldKey}`]) this.model[`${fieldKey}`] = null;
      this.doFilter();
    },

    debounceInput: _.debounce(function () {
      this.doFilter();
    }, 500),

    async doFilter() {
      const { filterSchema } = this;
      try {
        await this.$refs.form.validate();
        this.$refs.form.clearValidate();
      } catch (error) {
        return;
      }

      const filter = filterSchema.cast(this.model);
      return this.doFetch({
        filter,
      });
    },

    i18n(code) {
      return i18n(code);
    },
  },
};
</script>

<style>
</style>
